import {
  Tooltip as MUITooltip,
  TooltipProps as MUITooltipProps,
  SxProps,
} from '@mui/material';
import { bgColorsVars } from '@design-system/vars.css';
import { Typography } from '../typography/typography';
import { borderRadius, boxShadowLight, space } from '@design-system/tokens';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

export type TooltipProps = MUITooltipProps & {
  variant: 'light' | 'dark' | 'white';
  custom?: boolean;
  tooltipProps?: SxProps;
};

export const Tooltip = ({ tooltipProps, ...p }: TooltipProps) => {
  const tooltipColor =
    p.variant === 'white'
      ? bgColorsVars['W-100']
      : p.variant === 'dark'
        ? bgColorsVars['N-100']
        : bgColorsVars['N-40'];

  return (
    <MUITooltip
      {...p}
      title={
        typeof p.title === 'string' ? (
          <Typography
            as="div"
            variant="body"
            color={p.variant === 'dark' ? 'N-20' : 'N-100'}
            style={{ padding: `${space.s} ${space.m}` }}
            size="small"
          >
            {p.title}
          </Typography>
        ) : (
          <>{p.title}</>
        )
      }
      slotProps={{
        tooltip: {
          sx: {
            borderRadius: p.custom ? borderRadius.m : borderRadius.xs,
            padding: 0,
            boxShadow:
              p.variant === 'white' ? boxShadowLight[5] : boxShadowLight[8],

            bgcolor: tooltipColor,
            maxWidth: '428px',
            ...(tooltipProps || {}),
          },
        },
        arrow: { sx: { color: tooltipColor } },
      }}
    />
  );
};

export const FormTooltip = (p: Pick<TooltipProps, 'title' | 'custom'>) => (
  <Tooltip variant="dark" {...p}>
    <FontAwesomeIcon icon={faInfoCircle} />
  </Tooltip>
);
